<script lang="ts">
    import { _ } from "svelte-i18n"
    import { kirbyFetch } from "../../../../api/kirby/api"
    import { getPageSelect } from "../../../../api/kirby/queries"
    import MedialibImage from "../../../widgets/MedialibImage.svelte"
    import { animateOnVisible } from "../../../../configs/config"
    let { block }: { block: PersonDetailsCardsBlock } = $props()
    const cnt = block.content
    const persons: PersonpageContent[] = $state([])
    let active = $state(-1)
    Promise.all(
        cnt.persons.map((person) =>
            kirbyFetch<PersonpageContent>({
                query: `page("${person}")`,
                select: getPageSelect(),
            })
        )
    ).then((results) => {
        persons.push(...results)
        console.log("persons", persons)
        const commonProps = {
            duration: 300,
            opacity: [0, 1],
            easing: "cubicBezier",
        }
        animateOnVisible(".preview-list .content h3", {
            translateY: ["30px", "0rem"],
            scale: [0.7, 1],
            delay: 300,
            ...commonProps,
        })

        animateOnVisible(".preview-list .content .to-profile, .preview-list .content .department", {
            delay: 1000,
            ...commonProps,
        })
    })
</script>

<ul class="preview-list">
    {#each persons as person, idx (`person-${person.title}-${person.person_email}`)}
        <li>
            <div class="bg-image">
                <MedialibImage id={person.preview_img} alt="person preview" maxWidth={420} />
            </div>
            <div class="content">
                <span class="department">{person.department}</span>
                <div class="lower-content">
                    <h3>
                        {person.person_academic_titles.replaceAll(",", "")}
                        {person.person_name}
                    </h3>
                    <!-- svelte-ignore a11y_no_static_element_interactions -->
                    <button
                        onclick={() => (active = active == idx ? -1 : idx)}
                        class="to-profile"
                        class:active={active == idx}
                    >
                        <span>{$_("general.contact-info")}</span>
                        <span class="arrow" class:active={active == idx}>
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <g clip-path="url(#clip0_6779_3463)">
                                    <path
                                        d="M7.13092 5.68945L8.19157 6.75009L3.6917 11.25H46V12.75H3.69185L8.19157 17.2497L7.13092 18.3104L0.820377 11.9999L7.13092 5.68945Z"
                                        fill="#FFF"
                                    ></path>
                                </g>
                                <defs>
                                    <clipPath id="clip0_6779_3463">
                                        <rect width="24" height="24" fill="white" transform="matrix(-1 0 0 1 24 0)"
                                        ></rect>
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                    </button>
                    <ul class="contact-details" class:active={active == idx}>
                        {#if person.person_phone}
                            <li>
                                <a href={"tel:" + person.person_phone}>T {person.person_phone}</a>
                            </li>
                        {/if}
                        {#if person.person_email}
                            <li>
                                <a href={"mailto:" + person.person_email}>E {person.person_email}</a>
                            </li>
                        {/if}
                        {#if person.person_links && person.person_links.length > 0}
                            {#each person.person_links as { url, title, type } (`${type}-${url}`)}
                                <li>
                                    <a href={url} target="_blank">
                                        {#if type == "other"}
                                            <svg
                                                width="28"
                                                height="28"
                                                viewBox="0 0 28 28"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    fill-rule="evenodd"
                                                    clip-rule="evenodd"
                                                    d="M10.4999 7.875C10.2678 7.875 10.0453 7.78281 9.88118 7.61872C9.71709 7.45462 9.6249 7.23206 9.6249 7C9.6249 6.76794 9.71709 6.54538 9.88118 6.38128C10.0453 6.21719 10.2678 6.125 10.4999 6.125H20.9999C21.232 6.125 21.4545 6.21719 21.6186 6.38128C21.7827 6.54538 21.8749 6.76794 21.8749 7V17.5C21.8749 17.7321 21.7827 17.9546 21.6186 18.1187C21.4545 18.2828 21.232 18.375 20.9999 18.375C20.7678 18.375 20.5453 18.2828 20.3812 18.1187C20.2171 17.9546 20.1249 17.7321 20.1249 17.5V9.11167L7.61824 21.6183C7.45237 21.7729 7.23298 21.857 7.00629 21.853C6.77961 21.849 6.56333 21.7572 6.40301 21.5969C6.24269 21.4366 6.15086 21.2203 6.14686 20.9936C6.14287 20.7669 6.22701 20.5475 6.38157 20.3817L18.8882 7.875H10.4999Z"
                                                    fill="#242220"
                                                ></path>
                                            </svg>
                                        {:else}
                                            <svg
                                                width="28"
                                                height="28"
                                                viewBox="0 0 28 28"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                            >
                                                <path
                                                    d="M23.625 9.33333C23.625 8.0183 23.1022 6.7575 22.1724 5.82764C21.2425 4.89777 19.9817 4.375 18.6667 4.375H9.33333C8.0183 4.375 6.7575 4.89777 5.82764 5.82764C4.89777 6.7575 4.375 8.0183 4.375 9.33333V18.6667C4.375 19.9817 4.89777 21.2425 5.82764 22.1724C6.7575 23.1022 8.0183 23.625 9.33333 23.625H18.6667C19.9817 23.625 21.2425 23.1022 22.1724 22.1724C23.1022 21.2425 23.625 19.9817 23.625 18.6667V9.33333ZM7.29167 19.8333V11.6667C7.29167 11.1834 7.68342 10.7917 8.16667 10.7917C8.64992 10.7917 9.04167 11.1834 9.04167 11.6667V19.8333C9.04167 20.3166 8.64992 20.7083 8.16667 20.7083C7.68342 20.7083 7.29167 20.3166 7.29167 19.8333ZM18.9583 19.8333V16.0417C18.9583 15.2058 18.6344 14.6324 18.179 14.2529C17.7036 13.8568 17.0364 13.6354 16.3333 13.6354C15.6302 13.6354 14.9631 13.8568 14.4876 14.2529C14.0323 14.6324 13.7083 15.2058 13.7083 16.0417V19.8333C13.7083 20.3166 13.3166 20.7083 12.8333 20.7083C12.3501 20.7083 11.9583 20.3166 11.9583 19.8333V11.6667C11.9583 11.1834 12.3501 10.7917 12.8333 10.7917C13.3166 10.7917 13.7083 11.1834 13.7083 11.6667V12.6533C14.4874 12.1313 15.4238 11.8854 16.3333 11.8854C17.3801 11.8854 18.4631 12.211 19.3001 12.9085C20.1571 13.6228 20.7083 14.6902 20.7083 16.0417V19.8333C20.7083 20.3166 20.3166 20.7083 19.8333 20.7083C19.3501 20.7083 18.9583 20.3166 18.9583 19.8333ZM8.8138 8.76709C8.48871 9.12442 7.93513 9.1513 7.57764 8.82633C7.22009 8.50129 7.19454 7.94775 7.51953 7.59017L8.8138 8.76709ZM7.53092 7.5765C7.85602 7.21915 8.4096 7.1934 8.76709 7.51839C9.12441 7.84349 9.15131 8.39707 8.82633 8.75456L8.8138 8.76709L7.51953 7.59017L7.53092 7.5765ZM25.375 18.6667C25.375 20.4458 24.6677 22.1516 23.4097 23.4097C22.1516 24.6677 20.4458 25.375 18.6667 25.375H9.33333C7.55417 25.375 5.84839 24.6677 4.59033 23.4097C3.33228 22.1516 2.625 20.4458 2.625 18.6667V9.33333C2.625 7.55417 3.33228 5.84839 4.59033 4.59033C5.84839 3.33228 7.55417 2.625 9.33333 2.625H18.6667C20.4458 2.625 22.1516 3.33228 23.4097 4.59033C24.6677 5.84839 25.375 7.55417 25.375 9.33333V18.6667Z"
                                                    fill="#242220"
                                                ></path>
                                            </svg>
                                        {/if}

                                        <span>{title}</span>
                                    </a>
                                </li>
                            {/each}
                        {/if}
                    </ul>
                </div>
            </div>
        </li>
    {/each}
</ul>

<style lang="less" global>
    @import "../../../../css/variables.less";
    ul.preview-list {
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(408px, 1fr));
        gap: 1.2rem 2.4rem;
        @media @max-mobile {
            display: flex;
            flex-direction: column;
            gap: 1.2rem;
        }

        width: 100%;
        padding-top: 1.2rem;
        li {
            width: 100%;
            height: 568px;
            position: relative;

            .bg-image {
                position: absolute;
                top: 0px;
                left: 0px;
                width: 100%;
                height: 100%;
                z-index: 0;
                &::before {
                    position: absolute;
                    content: "";
                    z-index: 2;
                    top: 0px;
                    left: 0px;
                    width: 100%;
                    height: 100%;
                    background: radial-gradient(circle at 50% 50%, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.2) 100%);
                }
                img {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    position: relative;
                    border-radius: 4px;
                }
            }
            .content {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-start;
                position: relative;
                z-index: 2;

                height: 100%;
                & > span {
                    font-size: 14px;
                    font-weight: 700;
                    text-transform: uppercase;
                    color: var(--bright-100);
                    padding: 1.2rem;
                }
                .lower-content {
                    display: flex;
                    flex-direction: column;
                    gap: 0.6rem;
                    width: 100%;
                    h3 {
                        color: var(--bright-100);
                        padding: 0px 1.2rem;
                    }
                    .to-profile {
                        width: 100%;
                        display: flex;
                        justify-content: space-between;
                        padding: 0px 1.2rem;
                        span {
                            color: var(--bright-100);
                            font-size: 14px;
                            font-weight: 400;
                            text-transform: uppercase;
                            transition: color 0.3s;
                        }
                        .arrow {
                            transition: transform 0.3s;
                            transform: rotate(90deg);
                            transform-origin: center;
                            &.active {
                                transform: rotate(270deg);
                            }
                        }
                        &:hover span {
                            color: var(--brand-100);
                        }
                    }
                }

                .contact-details {
                    display: flex;
                    flex-direction: column;
                    height: fit-content;
                    max-height: 0px;
                    overflow: hidden;
                    transition: max-height 0.3s;
                    li {
                        border-top: 1px solid var(--bright-100);
                        background: rgba(36, 34, 32, 0.5);
                        backdrop-filter: blur(10px);
                        padding: 0.4rem 0.6rem;
                        display: flex;
                        align-items: center;
                        height: fit-content;
                        a {
                            color: var(--bright-100) !important;
                            transition: color 0.3s ease-in-out;
                            path {
                                fill: var(--bright-100) !important;
                                transition: fill 0.3s ease-in-out;
                            }

                            display: flex;
                            align-items: center;
                            height: fit-content;
                            gap: 0.6rem;
                        }
                        &:hover {
                            a {
                                color: var(--brand-100) !important;
                                path {
                                    fill: var(--brand-100) !important;
                                }
                            }
                        }
                    }
                    &.active {
                        max-height: 200px;
                    }
                }
            }
        }
    }
</style>
